'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";
import apiService from "@/Common/ApiService";

 

var OpenFileService = {

    vueComponent : null,
    ContextMenuItems: [],
    ContextMenuVisible: false,


    ControllerContextMenuX: 0,
    ControllerContextMenuY: 0,
    ControllerContextMenuItems: [],
    ControllerContextMenuVisible: false,


    GetAllComponents(parentComponent) {
        let comps = [];
        let i;

        if (parentComponent.$children != null) {

            parentComponent.$children.forEach(
                function (childComd) {
                    let childChildComps;

                    comps.push(childComd);

                    childChildComps = this.GetAllComponents(childComd);

                    comps.push(...childChildComps);
                }.bind(this)
            );
        }

        return comps;
    },

    OnContextMenu(_vueComponent,e) {
        let elementIdComponentDic = {};
        let parentElement;
        let filePaths = [];

        this.vueComponent = _vueComponent;

        if (window.location.href.indexOf("localhost") < 0) {
            return;
        }


        let comps = this.GetAllComponents(this.vueComponent);

        e.preventDefault();


        this.ClearAllToolButtons();

        this.ClearAllMarkedStyle();

        comps.forEach(
            (comp) => {
                if (comp.$el != null && comp.$el.style != null) {

                    if (elementIdComponentDic[comp._uid + ""] == null) {
                        elementIdComponentDic[comp._uid + ""] = comp;

                        comp.$el.setAttribute("_uid", comp._uid + "");
                    }
                }
            }
        );


        parentElement = e.srcElement;

        while (parentElement.tagName != "BODY") {

            if (parentElement.getAttribute("_uid") != null) {
                let comp;
                let uid;

                parentElement.classList.add("Marked");

                uid = parentElement.getAttribute("_uid");

                comp = elementIdComponentDic[uid]

                //alert(comp.$options.__file);
                filePaths.push(comp.$options.__file);
 
                this.CreateElementToolButtons(parentElement);
            }

            parentElement = parentElement.parentElement;
        }

        this.ContextMenuItems.length = 0;

        filePaths.forEach(
            (path) => {
                let tokens;
                let fileName;

                if (path != null) {
                    tokens = path.split("/");

                    fileName = tokens[tokens.length - 1];

                    this.ContextMenuItems.push(
                        {
                            ItemHtml: fileName + "  <span style='font-size:13px;color:#999999;'>" + "/wwwroot/" + path + "</span> ",
                            Path: "/wwwroot/" + path
                        }
                    );

                }

            }
        );

        this.ContextMenuItems.reverse();

        this.ContextMenuX = e.clientX - 5;


        if (Utility.GetBrowserWidth() - e.clientX < 300) {
            this.ContextMenuX -= 300;
        }

        this.ContextMenuY = Utility.GetScrollTop() + e.clientY - (this.ContextMenuItems.length * 36) - 6;



        this.ControllerContextMenuX = this.ContextMenuX;
        this.ControllerContextMenuY = Utility.GetScrollTop() + e.clientY + 15;


        this.ControllerContextMenuItems.length = 0;

        filePaths.forEach(
            (path) => {
                let tokens;
                let fileName;
                let controllerName;
                let controllerFilePath;

                if (path == null) {
                    return;
                }

                tokens = path.split("/");


                if (path.indexOf("Controls/") < 0 && path.indexOf("Layout/") < 0) {

                    fileName = tokens[tokens.length - 1];

                    fileName = fileName.replace(/List|Detail|Dialog/ig, "");

                    fileName = fileName.replace(".vue", "Controller.cs");

                    controllerName = tokens[tokens.length - 2];
                    controllerFilePath = "/Controllers/" + controllerName + "Controller.cs";

                    this.ControllerContextMenuItems.push(
                        {
                            ItemHtml: fileName + "  <span style='font-size:13px;color:#999999;'>" + controllerFilePath + "</span> ",
                            Path: "/Controllers/" + controllerName + "Controller.cs"
                        }
                    );
                }
            }
        );


        //this.ContextMenuVisible = true;
        this.ContextMenuVisible = false;

    },




    Clear() {
        this.ClearAllMarkedStyle();
        this.ClearAllToolButtons();
    } ,

    ClearAllToolButtons() {
        let toolButtonElements;
        let i;

        toolButtonElements = document.querySelectorAll(".ToolButton");

        for (i = 0; i < toolButtonElements.length; i++) {
            toolButtonElements[i].remove();
        }
    },


    ClearAllMarkedStyle() {
        let markedElements;
        let i;

        this.ContextMenuVisible = false;

        markedElements = document.querySelectorAll(".Marked");

        for (i = 0; i < markedElements.length; i++) {
            markedElements[i].classList.remove("Marked");
        }
    },

    ClearAllToolButtons() {
        let toolButtonElements;
        let i;

        toolButtonElements = document.querySelectorAll(".ToolButton");

        for (i = 0; i < toolButtonElements.length; i++) {
            toolButtonElements[i].remove();
        }
    },


    OnSourceToolButtonClick(e) {
        let sourceVue;
        let parentVue;
        let filePath;


        sourceVue = e.target.SourceElement.__vue__;

        if (sourceVue.$options._componentTag == "t-button") {

            let buttonText;

           
            parentVue = sourceVue.$parent;

            if (
                parentVue.$options._componentTag == "t-listview" ||
                parentVue.$options._componentTag == "t-tab"
            ) {
                parentVue = parentVue.$parent;
            }

            buttonText = sourceVue.$el.innerText;



            filePath = "/wwwroot/" + parentVue.$options.__file;



            this.GetFileContent(filePath).then(
                function (response) {
                    let buttonLineNumber;

                    buttonLineNumber = this.GetButtonLineNumber(buttonText, response.Content);

                    OpenFileService.OpenFile(filePath, buttonLineNumber);
                    //m = buttonTextRegex.exec(response.Content);

                    //if (m != null && m.length > 0) {
                    //    let lineNumber = 1;

                    //    lineNumber = this.GetLineNumberByIndex(response.Content, m.index);
                       
                    //    OpenFileService.OpenFile(filePath, lineNumber);
                    //}//end if (m != null && m.length > 0) {

                }.bind(this)
            );
        }
        else if (sourceVue.$refs.ListTable != null) {
            //t-listview

            parentVue = sourceVue.$parent;

            if (
                parentVue.$options._componentTag == "t-listview" ||
                parentVue.$options._componentTag == "t-tab"
            ) {
                parentVue = parentVue.$parent;
            }


            //ListView
             if (sourceVue.$props.QueryHandler != null) {
                let queryHnadlerName = sourceVue.$props.QueryHandler.name;
                let functionName;

                functionName = queryHnadlerName.replace("bound ", "");

                //alert(functionName);

                //alert(sourceVue.$options.__file);

                if (parentVue.$options.__file == null) {
                    Utility.ShowValidationMessage("parentVue.$options.__file is null !");
                    return;
                }

                filePath = "/wwwroot/" + parentVue.$options.__file;



                this.GetFileContent(filePath).then(
                    function (response) {
                        let m;
                        let queryHandlerRegex = new RegExp(
                            `:QueryHandler\\s*=\\s*"${functionName}"`, "ig");
                        //let queryHandlerRegex = new RegExp(
                        //                        `:QueryHandler`, "ig");


                        m = queryHandlerRegex.exec(response.Content);

                        if (m != null && m.length > 0) {
                            let lineNumber = 1;
                            let tListViewIndex;


                            tListViewIndex = response.Content.substr(0, m.index).lastIndexOf("<t-listview");

                            lineNumber = this.GetLineNumberByIndex(response.Content, tListViewIndex);

                            OpenFileService.OpenFile(filePath, lineNumber);
                        }//end if (m != null && m.length > 0) {

                    }.bind(this)
                );
            }
            else if (sourceVue.$vnode.data != null && sourceVue.$vnode.data.ref != null) {
                let refName;

                refName = sourceVue.$vnode.data.ref;
 
                if (parentVue.$options.__file == null) {
                    Utility.ShowValidationMessage("parentVue.$options.__file is null !");
                    return;
                }

                filePath = "/wwwroot/" + parentVue.$options.__file;

                this.GetFileContent(filePath).then(
                    function (response) {
                        let m;
                        let refRegex = new RegExp(
                            `ref\\s*=\\s*"${refName}"`, "ig");
                        //let queryHandlerRegex = new RegExp(
                        //                        `:QueryHandler`, "ig");


                        m = refRegex.exec(response.Content);

                        if (m != null && m.length > 0) {
                            let lineNumber = 1;
                            let tListViewIndex;


                            tListViewIndex = response.Content.substr(0, m.index).lastIndexOf("<t-listview");

                            lineNumber = this.GetLineNumberByIndex(response.Content, tListViewIndex);

                            OpenFileService.OpenFile(filePath, lineNumber);
                        }//end if (m != null && m.length > 0) {

                    }.bind(this)
                );
            }
            else {

                if (parentVue.$options._componentTag == "t-tab") {
                    parentVue = parentVue.$parent;
                }

                filePath = "/wwwroot/" + parentVue.$options.__file;

                OpenFileService.OpenFile(filePath, 0);
            }
        }
        else if ((sourceVue.$options._componentTag + "").indexOf("t-") == 0) {

 
            parentVue = sourceVue.$parent;

            while (true) {
                if (parentVue.$options._componentTag == "t-listview" ||
                    parentVue.$options._componentTag == "t-tab"
                ) {
                    parentVue = parentVue.$parent;
                }
                else {
                    break;
                }
            }
 
            filePath = "/wwwroot/" + parentVue.$options.__file;

            this.GetFileContent(filePath).then(
                function (response) {
                    let vModelExpression;
                    let tagName;
                    let lineNumber = 0;

                    tagName = sourceVue.$options._componentTag;
                    if (sourceVue.$vnode.data != null && sourceVue.$vnode.data.model != null) {
                        vModelExpression = sourceVue.$vnode.data.model.expression;

                        lineNumber = this.GetVModelTagNumber(tagName, vModelExpression, response.Content);
                    }

                    OpenFileService.OpenFile(filePath, lineNumber);

                }.bind(this)
            );
        }
        else {
            filePath = "";

            filePath = "/wwwroot/" + sourceVue.$options.__file;

            OpenFileService.OpenFile(filePath, 1);
        }

        e.preventDefault();

    },

    GetVModelTagNumber(tagName, vModelExpression, sourceContent) {
        let tagLineNumber = 0;
        let m;
        let tagExpression = new RegExp(
            `<${tagName}[^-]+-model=['"]${vModelExpression}['"]`, "ig");

        if (vModelExpression != null && vModelExpression != "") {
            m = tagExpression.exec(sourceContent);

            if (m != null) {
                tagLineNumber = this.GetLineNumberByIndex(sourceContent, m.index);
            }
        }

        return tagLineNumber;
    },


    GetButtonLineNumber(buttonText, sourceContent) {
        let buttonLineNumber = 0;
        let m, m2, m3;
        let buttonHtml;
        let buttonIndex;

        let buttonTextRegex = new RegExp(
            `<t-button[^\\>]+>\\s*${buttonText}\\s*</t-button>`, "ig");
        let clickRegex = /\@click\s*=\s*('([^']*)'|"([^"]*)")/i;

        sourceContent = sourceContent.replace(")=>", "   ");

        m = buttonTextRegex.exec(sourceContent);

        if (m != null && m.length > 0) {
            buttonLineNumber = this.GetLineNumberByIndex(sourceContent, m.index);
        }
        else {
            Utility.ShowMessage("Can not find t-button with text : " + buttonText);
            throw ("Can not find t-button with text : " + buttonText);
        }
        //end if (m != null && m.length > 0) {


        return buttonLineNumber;
    } ,


    GetFunctionNameByButtonText(buttonText, sourceContent) {
        let functionName = null;
        let m, m2, m3;
        let buttonHtml;
        let buttonTextRegex = new RegExp(
            `<t-button[^\\>]+>\\s*${buttonText}\\s*</t-button>`, "ig");
        let clickRegex = /\@click\s*=\s*('([^']*)'|"([^"]*)")/i;


        m = buttonTextRegex.exec(sourceContent);

        if (m != null && m.length > 0) {
            let lineNumber = 1;

            buttonHtml = m[0];

            m2 = clickRegex.exec(buttonHtml);

            if (m2 != null && m2.length > 0) {
                let handler;

                if (m2[2] != null) {
                    handler = m2[2];
                }
                else {
                    handler = m2[3];
                }


                functionName = handler.replace(/\([^\)]*\)/ig, "");
            }
 


        }//end if (m != null && m.length > 0) {


        return functionName;
    },


    GetFunctionLineNumber(functionName, sourceContent) {
        let lineNumber = 0;
        let functionNameRegex;
        let m3;

        functionNameRegex = new RegExp(
            `\\s` + functionName + `\\s*\\([^\\s]*\\)`, "ig");

        m3 = functionNameRegex.exec(sourceContent);


        if (m3 != null) {
            lineNumber = this.GetLineNumberByIndex(sourceContent, m3.index);

        }
        else {
            Utility.ShowMessage("Can not find Function  " + functionName);
        }

        return lineNumber;
    },


    GetFunctionContent(functionName, sourceContent) {
        let functionContent ="";
        let functionNameRegex = new RegExp(
            `\\s` + functionName + `\\s*\\([^\\)]*\\)`, "ig");
        let functionEndIndex;
        let m3;


        if (sourceContent == null) {
            Utility.ShowMessage("sourceContent can not be null !");
            throw ("sourceContent can not be null !");
        }
         
        m3 = functionNameRegex.exec(sourceContent);

        if (m3 != null) {

            functionEndIndex = this.GetFunctionEndIndex(sourceContent, m3.index);

            if (functionEndIndex < 0) {
                Utility.ShowMessage("Can not detect functionIndex ");
                return;
            }

            functionContent = sourceContent.substr(m3.index, functionEndIndex - m3.index + 1);
        }
        else {
            Utility.ShowMessage("Can not find function : " + functionName);
            throw ("Can not find function : " + functionName);
        }

        return functionContent;
    },


    GetApiPostPath(sourceCount) {
        let apiPostRegex = /apiService\.Post\s*\(\s*["\`]([^"\`]+)["\`]/ig;
        let postPath = "";
        let m4;

        m4 = apiPostRegex.exec(sourceCount);

        if (m4 == null) {

            return null;
        }

        postPath = m4[1];
         
        return postPath;
    },


    OpenControllerByApiPath(apiPath) {
        let tokens;
        let controllerPath;

        tokens = apiPath.split("/");

        controllerPath = "/Controllers/" + tokens[2] + "Controller.cs";

        this.GetFileContent(controllerPath).then(
            function (response) {
                let lineNumber = 1;
                let index;

                index = response.Content.indexOf(`[HttpPost(\"${apiPath}\")]`);


                lineNumber = this.GetLineNumberByIndex(response.Content, index);

                OpenFileService.OpenFile(controllerPath, lineNumber);

            }.bind(this)
        ).catch(
            (e) => {
                alert(e)
            }
        );
    },//end OpenControllerByApiPath(apiPath) {


    OnFunctionToolButtonClick(e) {
        let sourceVue;
        let parentVue;
        let filePath;
         

        sourceVue = e.target.SourceElement.__vue__;

        if (sourceVue.$options._componentTag == "t-button") {

            let buttonText;

            parentVue = sourceVue.$parent;

            if (parentVue.$options._componentTag == "t-listview" ||
                parentVue.$options._componentTag == "t-tab"
            ) {
                parentVue = parentVue.$parent;
            }

            buttonText = sourceVue.$el.innerText;



            filePath = "/wwwroot/" + parentVue.$options.__file;



            this.GetFileContent(filePath).then(
                function (response) {
                    let functionName;
                    let functionLineNumber;


                     functionName = this.GetFunctionNameByButtonText(buttonText, response.Content);

                    if (functionName == null || functionName == "") {
                        Utility.ShowMessage("Can not detect button function");
                        throw ("Can not detect button function");
                    }

                    functionLineNumber = this.GetFunctionLineNumber(functionName, response.Content);

                    OpenFileService.OpenFile(filePath, functionLineNumber);

                }.bind(this)
            );
        }
        else if (sourceVue.$refs.ListTable != null) {
            //t-listview

            parentVue = sourceVue.$parent;

            //ListView
            if (sourceVue.$props.QueryHandler != null) {
                let queryHnadlerName = sourceVue.$props.QueryHandler.name;
                let functionName;



                functionName = queryHnadlerName.replace("bound ", "");

                //alert(functionName);

                //alert(sourceVue.$options.__file);

                filePath = "/wwwroot/" + parentVue.$options.__file;



                this.GetFileContent(filePath).then(
                    function (response) {
                        let m;
                        let queryHandlerRegex = new RegExp(
                            `:QueryHandler\\s*=\\s*"${functionName}"`, "ig");
                        //let queryHandlerRegex = new RegExp(
                        //                        `:QueryHandler`, "ig");


                        m = queryHandlerRegex.exec(response.Content);

                        if (m != null && m.length > 0) {
                            let lineNumber = 1;

                            lineNumber = this.GetLineNumberByIndex(response.Content, m.index);

                            OpenFileService.OpenFile(filePath, lineNumber);
                        }//end if (m != null && m.length > 0) {

                    }.bind(this)
                );
            }
        }
        else if ((sourceVue.$options._componentTag + "").indexOf("t-") == 0) {

            let buttonText;



            parentVue = sourceVue.$parent;

            if (parentVue.$options._componentTag == "t-listview") {
                parentVue = parentVue.$parent;
            }

            buttonText = sourceVue.$el.innerText;



            filePath = "/wwwroot/" + parentVue.$options.__file;




            this.GetFileContent(filePath).then(
                function (response) {




                    OpenFileService.OpenFile(filePath, 0);


                }.bind(this)
            );
        }

        else {
            filePath = "";

            filePath = "/wwwroot/" + sourceVue.$options.__file;

            OpenFileService.OpenFile(filePath, 1);
        }

        e.preventDefault();

    },

    CreateElementToolButtons(element) {
        let toolButtonElement;
        let uid;
        let l, t;

        uid = element.getAttribute("_uid");
 
        toolButtonElement = document.getElementById("ToolButton_" + uid);

        if (toolButtonElement == null) {

            toolButtonElement = document.createElement("DIV");
            toolButtonElement.classList.add("ToolButton");
            toolButtonElement.classList.add("Source");
 
      

            l = Utility.GetClientLeft(element) + "px";
            t = Utility.GetClientTop(element) - 30 + "px";

            toolButtonElement.style.left = l;
            toolButtonElement.style.top = t;
            toolButtonElement.style.whiteSpace = "nowrap";
            toolButtonElement.innerText = "S ";
            toolButtonElement.uid = uid;
            toolButtonElement.SourceElement = element;
            
            toolButtonElement.addEventListener("click", this.OnSourceToolButtonClick.bind(this));

            document.body.insertAdjacentElement("BeforeBegin", toolButtonElement);


            if (
                element.children.length > 0 &&
                element.children[0].classList.contains("ListTable")) {
                toolButtonElement = document.createElement("DIV");
                toolButtonElement.classList.add("ToolButton");
                toolButtonElement.classList.add("Controller");
                toolButtonElement.uid = uid;
                toolButtonElement.SourceElement = element;
                toolButtonElement.style.left = (Utility.GetClientLeft(element) + 33) + "px";
                toolButtonElement.style.top = (Utility.GetClientTop(element) - 30) + "px";
                toolButtonElement.innerText = "C";

                toolButtonElement.addEventListener("click", this.OnControllerToolButtonClick.bind(this));

            }
            else if (element.__vue__.$options._componentTag == "t-button") {
 
                    toolButtonElement = document.createElement("DIV");
                    toolButtonElement.classList.add("ToolButton");
                    toolButtonElement.classList.add("Function");
                    toolButtonElement.uid = uid;
                    toolButtonElement.SourceElement = element;
                    toolButtonElement.style.left = (Utility.GetClientLeft(element) + 33) + "px";
                    toolButtonElement.style.top = (Utility.GetClientTop(element) - 30) + "px";
                    toolButtonElement.innerText = "F";

                    toolButtonElement.addEventListener("click", this.OnFunctionToolButtonClick.bind(this));


                    //#region Button Controller
                let toolButtonElement2;
                toolButtonElement2 = document.createElement("DIV");
                toolButtonElement2.classList.add("ToolButton");
                toolButtonElement2.classList.add("Controller");
                toolButtonElement2.uid = uid;
                toolButtonElement2.SourceElement = element;
                toolButtonElement2.style.left = (Utility.GetClientLeft(element) + 33 + 33) + "px";
                toolButtonElement2.style.top = (Utility.GetClientTop(element) - 30) + "px";
                toolButtonElement2.innerText = "C";

                toolButtonElement2.addEventListener("click", this.OnControllerToolButtonClick.bind(this));

                document.body.insertAdjacentElement("BeforeBegin", toolButtonElement2);

                    //#endregion

            }

            document.body.insertAdjacentElement("BeforeBegin", toolButtonElement);
        }
    },

    ChangeStyleSheetRuleBackgroundImage() {
        let sheet, rule;
        let virtualDirectory = "";



        if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {
            if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                virtualDirectory = AppSettings.VirtualDirectory;
            }
        }

        for (var i = 0; i < document.styleSheets.length; i++) {
            sheet = document.styleSheets[i];

            for (var j = 0; j < sheet.cssRules.length; j++) {
                rule = sheet.cssRules[j];

                if (rule.selectorText != null) {
                    if (rule.selectorText.indexOf(".Button") >= 0 ||
                        rule.selectorText.indexOf(".DragHandle") >= 0
                    ) {

                        if (rule.style.backgroundImage != null) {
                            if (rule.style.backgroundImage.indexOf("url(\"/static") == 0) {
                                if (virtualDirectory != "") {
                                    rule.style.backgroundImage =
                                        rule.style.backgroundImage.replace(
                                            "url(\"/static",
                                            "url(\"/" + virtualDirectory + "/static" ,
                                        );
                                }
                            }
                        }
                    }
                }
            }
        }
    },


    GetLineNumberByIndex(fileContent, index) {
        let lineNumber = -1;
        let prevContent;
        let ms;

        prevContent = fileContent.substr(0, index);

        ms = prevContent.match(/\r\n|\r/ig);

        if (ms != null && ms.length > 0) {
            lineNumber = ms.length - 1;

            if (lineNumber < 1) {
                lineNumber = 1;
            }
        }

        return lineNumber;
    },


    OnControllerToolButtonClick(e) {
        let sourceVue;
        let parentVue;
        let filePath;

         

        sourceVue = e.target.SourceElement.__vue__;
 
        if (sourceVue.$refs.ListTable != null) {
            //t-listview

            parentVue = sourceVue.$parent;

            //ListView
            if (sourceVue.$props.QueryHandler != null) {
                let queryHnadlerName = sourceVue.$props.QueryHandler.name;
                let functionName;



                functionName = queryHnadlerName.replace("bound ", "");

                //alert(functionName);

                //alert(sourceVue.$options.__file);

                filePath = "/wwwroot/" + parentVue.$options.__file;


                this.GetFileContent(filePath).then(
                    function (response) {
                        let functionContent;
                        let apiPath;
                        let tokens;
                        let m;
                        let tableName = "";
                        let tableNameRegex = /TableName\s*:\s*"([a-z|0-9]+)"/ig;

                        //let apiPostRegex = /apiService\\.Post\\("[^"]+"\\)/ig;
                        let apiPostRegex = /apiService\.Post\s*\(\s*["\`]([^"\`]+)["\`]/ig;
                        //let apiPostRegex = /apiService\.Post\s*\(\s*\`([^']+)\`/ig;

                        let functionRegex = new RegExp(`\\s+${functionName}\\([^\\)]*\\)`, "ig");
                        //let queryHandlerRegex = new RegExp(
                        //                        `:QueryHandler`, "ig");


                        m = tableNameRegex.exec(response.Content);

                        if (m != null) {
                            tableName = m[1];
                        }
                        m = functionRegex.exec(response.Content);

                        if (m != null && m.length > 0) {

                            functionContent = response.Content.substr(m.index, 2000);


                            m = apiPostRegex.exec(functionContent);

                            apiPath = m[1];

                            apiPath = apiPath.replace("${this.TableName}", tableName);


                            return Promise.resolve(apiPath);

                        }//end if (m != null && m.length > 0) {

                    }.bind(this)
                ).then(
                    function (apiPath) {
                        let tokens;
                        let controllerPath;
                        let apiName;


                        tokens = apiPath.split("/");

                        controllerPath = "/Controllers/" + tokens[2] + "Controller.cs";

                        this.GetFileContent(controllerPath).then(
                            function (response) {
                                let prevContent;
                                let ms;
                                let lineNumber = 1;
                                let index;

                                index = response.Content.indexOf(`[HttpPost(\"${apiPath}\")]`);


                                lineNumber = this.GetLineNumberByIndex(response.Content, index);

                                OpenFileService.OpenFile(controllerPath, lineNumber);

                            }.bind(this)
                        ).catch(
                            (e) => {
                                alert(e)
                            }
                        );


                    }.bind(this)
                );
            }
        }
        else {
            //Button 
            let buttonText;

            parentVue = sourceVue.$parent;

            if (parentVue.$options._componentTag == "t-listview" ||
                parentVue.$options._componentTag == "t-tab"
            ) {
                parentVue = parentVue.$parent;
            }

            buttonText = sourceVue.$el.innerText;



            filePath = "/wwwroot/" + parentVue.$options.__file;



            this.GetFileContent(filePath).then(
                function (response) {
                    let m, m2, m3;
                    let buttonHtml;
                    let buttonTextRegex = new RegExp(
                        `<t-button[^\\>]+>\\s*${buttonText}\\s*</t-button>`, "ig");
                    let clickRegex = /\@click=['"]([^'""]+)['""]/i;
                    let tableName = "";
                    let tableNameRegex = /TableName\s*:\s*"([a-z|0-9]+)"/ig;
                    //let apiPostRegex = /apiService\\.Post\\("[^"]+"\\)/ig;
                    let apiPostRegex = /apiService\.Post\s*\(\s*["\`]([^"\`]+)["\`]/ig;
                    //let apiPostRegex = /apiService\.Post\s*\(\s*\`([^']+)\`/ig;
 


                    m = tableNameRegex.exec(response.Content);
                    if (m != null) {
                        tableName = m[1];
                    }

                    let functionName;
                    let functionContent;
                    let apiPostPath;

                    functionName = this.GetFunctionNameByButtonText(buttonText, response.Content);


                    if (functionName == null || functionName == "") {
                        Utility.ShowMessage("Can not detect button function");
                        throw ("Can not detect button function");
                    }

                    functionContent = this.GetFunctionContent(functionName, response.Content);

                    apiPostPath = this.GetApiPostPath(functionContent);

                    if (apiPostPath == null || apiPostPath == "") {
                        Utility.ShowMessage("functionContent has no apiService.Post ! " +
                            `<div class=FunctionContent> 
` +
                            functionContent + `


</div>`  ,
                            3000
                        );
                        return;
                    }

                    apiPostPath = apiPostPath.replace("${this.TableName}", tableName);
                    apiPostPath = apiPostPath.replace("${TableName}", tableName);

                 

                    this.OpenControllerByApiPath(apiPostPath);

                }.bind(this)
            );
        }

        e.preventDefault();
    },


    GetFunctionEndIndex(functionContent, functionStartIndex) {
        let endIndex = -1;
        let bracketCount = 0;
        let i;

        for (i = functionStartIndex; i < functionContent.length; i++) {
            if (functionContent[i] == "{") {
                bracketCount++;
            }
            else if (functionContent[i] == "}") {
                bracketCount--;

                if (bracketCount == 0) {
                    endIndex = i;
                    break;
                }
            }
        }

        return endIndex;
    },

    OnConextMenuItemClick(item) {

        this.OpenFile(item.Path, 1);
    },

    GetFileContent(filePath) {
        return apiService.Post("/api/Util/GetFileContent", {
            FilePath: filePath
        });
    },

    OpenFile(filePath, lineNumber) {

        if (filePath == null) {
        }

        apiService.Post("/api/Util/OpenFile", {
            FilePath: filePath,
            LineNumber: lineNumber
        }).then(
            () => {

            }
        ).catch(
            () => {
                alert("catch")
            }
        );
    },
     
}


export default OpenFileService;

